import { combineReducers } from 'redux';

import apiError from './apiError';
import expandedSearch from './expandedSearch';
import filters from './filters';
import ids from './ids';
import isLoading from './isLoading';
import isVisible from './isVisible';
import page from './page';
import sort from './sort';

/**
 * @typedef {{
 *  ids : import('./ids').State;
 *  sort : import('./sort').State;
 *  page : import('./page').State;
 *  filters : import('./filters').State;
 *  apiError : import('./apiError').State;
 *  isLoading : import('./isLoading').State;
 *  isVisible : import('./isVisible').State;
 *  expandedSearch : import('./expandedSearch').State;
 * }} State
 */

export default combineReducers({
  ids,
  sort,
  page,
  filters,
  apiError,
  isLoading,
  isVisible,
  expandedSearch,
});
